// routesData.js

// Route configuration data
// Defines the routes and their corresponding components for the application

import MainParentComponent from "../../pages/Contact/MainDataTable";
// import FeedbackMainDataTable from "../../pages/Feedback/FeedbackMainDataTable";
import ErrorPage from "../../pages/Error/ErrorPage";
import {
  Contact,
  AddContact,
  EditContact,
  ContactDetails,
  CompanyDrive,
  Version,
  EmployeeList,
  VLoyalty,
  AddCampaign,
  EditCampaign,
  CampaignDetails,
  
  // Error404,
} from "./components";

import NativeSetting from "../../pages/NativeSetting/NativeSetting";
import PromotionMain from "../../pages/Promotion/PromotionMain";
import DeliveryChargeMain from "../../pages/DeliveryCharge/DeliveryCharge";
import DeliverySlot from "../../pages/DeliverySlot/DeliverySlot";
import SubscriptionCreate from "../../pages/Subcription/NewSubscription";
import DeliverySheetForm from "../../pages/DeliverySheet/DeliverySheet"
import Subscription from "../../pages/Subcription/SubcriptionMain"
import DeliverySheet from "../../pages/DeliverySheet/DeliverySheetMain";
// import CashManagement from "../../pages/CashManagement/CashManagementMain";
// import RouteMapper from "../../pages/Route/ShortRouteMap";
import ApartmentManagementMain from "../../pages/Apartment/apartment";
export const RoutesData = [
  { path: "/reactcontact", exact: true, element: <MainParentComponent navUrl="Contact" /> },
  { path: "/reactcontact/new", element: <AddContact navUrl="Contact" /> },
  {
    path: "/reactcontact/:contactId/edit",
    element: <EditContact navUrl="Contact" />,
  },
  {
    path: "/reactcontact/:contactType/:contactId",
    element: <ContactDetails navUrl="Contact" />,
  },
  {path: "/loyalty", exact: true, element: <VLoyalty navUrl="Loyalty"/>},
  {path: "/loyalty/campaign/new", element: <AddCampaign />},
  {
    path: "/loyalty/campaign/:campaignId/edit",
    element: <EditCampaign />,
  },
  {
    path: "/loyalty/campaign/:campaignId",
    element: <CampaignDetails />,
  },
  { path: "/drive", element: <CompanyDrive navUrl="Company Drive" /> },
  { path: "/setting/nativeSetting", element: <NativeSetting navUrl="Native Setting" /> },
  { path: "/changelog", element: <Version navUrl="Changelog" /> },
  // { path: "/reactemployee", element: <EmployeeList navUrl="Employee" /> },
  { path: "/promotion", element: <PromotionMain navUrl="Promotion" /> },
  { path: "/nativeDeliveryCharge", element: <DeliveryChargeMain navUrl="Delivery Charge" /> },
  { path: "/deliveryslot", element: <DeliverySlot navUrl="Delivery Slot" /> },
  { path: "/subcription/create", element: <SubscriptionCreate navUrl="Create Subscription" /> },
  { path: "/subscription", element: <Subscription navUrl="Subscription" /> },
  // { path: "/cashmanagement", element: <CashManagement navUrl="Cash Management" /> },
  // { path: "/routemap", element: <RouteMapper navUrl="Cash Management" /> },
  { path: "/apartment", element: <ApartmentManagementMain navUrl="Apartment" /> },
  { path: "/deliverySheet/create", element: <DeliverySheetForm navUrl="Create Delivery Sheet" /> },
  { path: "/deliverySheet/view", element: <DeliverySheetForm navUrl="View Delivery Sheet" /> },
  { path: "/delivery", element: <DeliverySheet navUrl="Delivery Sheet" /> },
  { path: "*", element: <ErrorPage /> },
  // Add more routes here
];
